import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class EnvService {
	private apiUrl: string;
	private uploaderApiUrl: string;
	private coachApiRoot: string;
	private coachAudioRoot: string;
	private stage: string;

	constructor() {
		this.apiUrl = environment.apiUrl;
		this.uploaderApiUrl = environment.uploaderApiUrl;
		this.coachApiRoot = environment.coachApiRoot;
		this.coachAudioRoot = environment.coachAudioRoot;
		this.stage = environment.stage;
	}

	public getStage(): string {
		return this.stage;
	}

	public getApiUrl(): string {
		return this.apiUrl;
	}

	public getUploaderApiUrl(): string {
		return this.uploaderApiUrl;
	}

	public getCoachApiRoot(): string {
		return this.coachApiRoot;
	}

	public getCoachAudioRoot(): string {
		return this.coachAudioRoot;
	}
}
